module.exports = __webpack_public_path__ + "static/media/football-carousel-2-1280x800.9e5974c1.jpg";